define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/locale"
], function(declare,NumberRen,locale) {

	return declare(NumberRen, {
		// Number: conversion factor to be used for all display (attr value * _nFactor) and editing (entered value / _nFactor)
		_nFactor: 1.0 / 1024.0,

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert value to displayed value - Show 'Unlimited' if the value is zero
			return (Number(value) <= 0) ? locale.resource("Unlimited") : this.inherited(arguments);
		}
	});
});